module.exports = __webpack_public_path__ + "img/banner.202c30ea.png";